(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sectionRoot) {
    var root = sectionRoot.querySelector('[data-hc-root]');
    if (!root) return;

    var track = root.querySelector('[data-hc-track]');
    var viewport = root.querySelector('.hc__viewport');
    var originalSlides = root.querySelectorAll('[data-hc-slide]');
    var dots = root.querySelectorAll('[data-hc-dot]');
    var count = originalSlides.length;

    if (!track || !viewport || count <= 1) return;

    // --- 无缝循环核心：动态克隆首尾 ---
    var firstClone = originalSlides[0].cloneNode(true);
    var lastClone = originalSlides[count - 1].cloneNode(true);
    track.appendChild(firstClone);
    track.insertBefore(lastClone, originalSlides[0]);

    var transition = parseInt(root.dataset.transition || '400', 10);
    var autoplay = root.dataset.autoplay === 'true';
    var stay = parseInt(root.dataset.stay || '4500', 10);

    // 初始索引设为 1（因为 0 现在是克隆的最后一张）
    var index = 1; 
    var timer = null;
    var isTransitioning = false;

    function apply(withTransition) {
      if (!withTransition) {
        track.style.transition = 'none';
      } else {
        track.style.transition = 'transform ' + transition + 'ms ease';
      }
      // 计算位移：因为多了个克隆层，所以要乘以 index
      var x = -index * 100;
      track.style.transform = 'translate3d(' + x + '%, 0, 0)';

      // 更新指示器点点
      if (dots && dots.length) {
        var dotActiveIndex = index - 1;
        if (index === 0) dotActiveIndex = count - 1;
        if (index === count + 1) dotActiveIndex = 0;
        dots.forEach(function (btn) {
          btn.classList.toggle('is-active', parseInt(btn.dataset.index, 10) === dotActiveIndex);
        });
      }
    }

    // 核心：监听动画结束，实现瞬间跳转
    track.addEventListener('transitionend', function() {
      isTransitioning = false;
      if (index === 0) { // 划到了头部的假图，瞬间跳回尾部的真图
        index = count;
        apply(false);
      } else if (index === count + 1) { // 划到了尾部的假图，瞬间跳回头部的真图
        index = 1;
        apply(false);
      }
    });

    function setIndex(i, restart) {
      if (isTransitioning) return;
      isTransitioning = true;
      index = i;
      apply(true);
      if (restart) { stop(); start(); }
    }

    function next() { setIndex(index + 1, false); }
    function prev() { setIndex(index - 1, false); }

    function start() { if (autoplay) { stop(); timer = window.setInterval(next, stay); } }
    function stop() { if (timer) { window.clearInterval(timer); timer = null; } }

    if (dots && dots.length) {
      dots.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          setIndex(parseInt(btn.dataset.index, 10) + 1, true);
        });
      });
    }

    /* Drag / Swipe 逻辑：解锁边缘阻力 */
    var isDown = false, startX = 0, deltaX = 0, didMove = false;
    function baseX() { return -index * viewport.clientWidth; }

    function onDown(clientX) {
      if (isTransitioning) return;
      stop();
      isDown = true; didMove = false; deltaX = 0; startX = clientX;
      root.classList.add('is-dragging');
      track.style.transition = 'none';
    }

    function onMove(clientX) {
      if (!isDown) return;
      deltaX = clientX - startX;
      if (Math.abs(deltaX) > 5) didMove = true;
      var x = baseX() + deltaX;
      track.style.transform = 'translate3d(' + x + 'px,0,0)';
    }

    function onUp() {
      if (!isDown) return;
      isDown = false;
      root.classList.remove('is-dragging');
      var threshold = Math.max(40, viewport.clientWidth * 0.15);
      if (Math.abs(deltaX) >= threshold) {
        if (deltaX < 0) next(); else prev();
      } else {
        apply(true);
      }
      start();
    }

    viewport.addEventListener('mousedown', function(e) { if(e.button===0) onDown(e.clientX); });
    window.addEventListener('mousemove', function(e) { onMove(e.clientX); });
    window.addEventListener('mouseup', onUp);
    viewport.addEventListener('touchstart', function(e) { onDown(e.touches[0].clientX); }, {passive:true});
    viewport.addEventListener('touchmove', function(e) { 
      onMove(e.touches[0].clientX); 
      if (Math.abs(deltaX) > 10) e.preventDefault(); 
    }, {passive:false});
    viewport.addEventListener('touchend', onUp);

    apply(false);
    start();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.section-wrapper').forEach(function (sec) { init(sec); });
  });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
